<template>
<div
  class="tickets-index"
  v-loading="loading"
>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-8">
          <customer-card
            :customer="customer"
            @editAdditionalData="enableEditAdditionalData($event)"
          ></customer-card>
        </div>
        <div class="col-md-4">
          <customer-image-card
            :timestamp-image="currentTimestamp"
            :customer="customer"
            :hasImage="hasImage"
            @editImage="enableEditImage()"
          ></customer-image-card>
        </div>
      </div>

      <div
        class="col-md-12"
        v-if="!hasAdditionalData"
      >
        <div class="alert alert-warning">
          <span><b>Atenção!</b> Preencha os campos abaixo para gerar um novo ticket.</span>
        </div>
      </div>

      <additional-data-form
        v-if="showAdditionalDataForm"
        @on-save="additionalDataSaved($event)"
        :customer="customer"
      ></additional-data-form>

      <customer-image-capture
        v-if="showImageCapture && !this.config.useLGPD"
        @on-image-captured="handleImageSave($event)"
      ></customer-image-capture>

      <!-- <div v-if="hasImage && hasAdditionalData"> -->
        <ticket-form
          :tickets="tickets"
          :customer="customer"
          :winnerLoaded="winnerLoaded"
          v-loading="enableForm"
          @on-ticket-create="handleFetchTickets()"
        ></ticket-form>
      <!-- </div> -->

      <tickets-list
        :tickets="tickets"
        :customers="customers"
        :loading="loading"
        scope="customer"
      ></tickets-list>
    </div>
  </div>

  <div class="row">
    <div
      class="col-md-12 text-right"
      style="margin-bottom: 20px;"
    >

      <router-link :to="{name: 'customers.create'}">
        <button class="btn btn-lg btn-fill btn-info"><i class="ti-plus"></i>
          Novo Cliente
        </button>
      </router-link>

      <router-link :to="lampsRoute">
        <a
          v-if="$can('customers.lamps')"
          class="btn btn-lg btn-fill btn-success"
        ><i class="fa fa-lightbulb-o"></i> Trocar Lâmpadas </a>
      </router-link>

    </div>
  </div>
</div>
</template>

<script>
import TicketForm from './TicketForm'
import TicketsList from './TicketsList'
import { mapActions, mapGetters } from 'vuex'
import blobUtil from 'blob-util'
import CustomerCard from 'src/pages/Customers/CustomerCard.vue'
import CustomerImageCard from 'src/pages/Customers/CustomerImageCard.vue'
import CustomerImageCapture from 'src/pages/Customers/CustomerImageCapture.vue'
import AdditionalDataForm from 'src/pages/Customers/Forms/AdditionalDataForm.vue'
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'

export default {
  components: {
    CustomerCard,
    CustomerImageCard,
    AdditionalDataForm,
    CustomerImageCapture,
    CircleChartCard,
    TicketForm,
    TicketsList
  },
  data () {
    return {
      currentTimestamp: new Date().getTime(),
      model: {},
      entityName: 'Tickets',
      isEditingAdditionalDataForm: false,
      isEditingImage: false,
      winnerLoaded: false,
      tireiFoto: false,
      hasImage: false
    }
  },

  computed: {
    ...mapGetters(['config']),

    loading: {
      get () {
        return this.$store.state.customers.loading
      }
    },

    customer: {
      get () {
        return this.$store.state.customers.one
      }
    },

    customers () {
      const id = this.customer._id
      return id ? {
        id: this.customer
      } : {}
    },

    tickets () {
      return this.$store.state.tickets.all
    },

    ticketsCount () {
      return this.tickets.length
    },

    id () {
      return this.$route.params.id
    },

    customerImageClass () {
      return {
        'img-responsive': true,
        'center-block': true,
        'img-customer-placeholder': !this.hasImage,
        'img-thumbnail': this.hasImage
      }
    },

    hasAdditionalData () {
      return this.customer.address && this.customer.address.complement !== '' && this.customer.address.complement.length > 0
    },

    showAdditionalDataForm () {
      return !this.hasAdditionalData || this.isEditingAdditionalDataForm
    },

    showImageCapture () {
      return (!this.hasImage/* && !this.hasAdditionalData */) || this.isEditingImage
    },

    lampsRoute () {
      if (this.customer._id) {
        return {
          name: 'customers.lamps',
          params: { id: this.customer._id }
        }
      } else {
        return { name: 'customers.index' }
      }
    },

    enableForm () {
      return !this.loading && this.winnerLoaded
    }
  },

  watch: {
    customer () {
      this.$nextTick(() => {
        if (this.customer && this.customer._id) {
          this.handleFetchWinner()
        }
        this.hasImage = this.customer.hasOwnProperty('_attachments') && this.customer._attachments.hasOwnProperty(
          'image.jpg')
      })
    }
  },

  methods: {
    ...mapActions('customers', {
      resetCustomer: 'resetOne',
      fetchCustomer: 'fetchOne',
      getUrlImg: 'getUrlImg',
      resetUrlImg: 'resetUrlImg',
      uploadCustomerImage: 'uploadCustomerImage'
    }),

    ...mapActions('winners', {
      fetchWinner: 'fetchAll',
      resetWinner: 'resetOne'
    }),

    ...mapActions('events', {
      fetchEvents: 'fetchAll'
    }),

    ...mapActions('tickets', {
      fetchTickets: 'fetchAll'
    }),

    ...mapActions('users', {
      fetchUsers: 'fetchAll'
    }),

    async handleFetchWinner () {
      this.winnerLoaded = false
      this.resetWinner()
      let where = []
      if (this.config.validationContemplatedCustomer.uc) {
        where.push({ uc: this.customer.uc })
      }
      if (this.config.validationContemplatedCustomer.cpf) {
        where.push({ cpf: this.customer.cpf.replace(/\D/g, '') })
      }
      if (this.config.validationContemplatedCustomer.ucOrCpf) {
        where = [{ '$or': where }]
      }
      if (where.length > 0) {
        this.fetchWinner({ where })
      }
      this.winnerLoaded = true
    },

    getCustomer () {
      return this.fetchCustomer(this.id)
        .then((response) => {
          this.hasImage = this.customer.hasOwnProperty('_attachments') && this.customer._attachments.hasOwnProperty('image.jpg')
          this.getUrlImg({id: this.id})
          this.currentTimestamp = new Date().getTime()
          this.handleFetchWinner()
          return response
        })
    },

    async handleFetchTickets () {
      this.getCustomer()
      location.reload()
    },

    handleImageSave (data) {
      blobUtil.imgSrcToBlob(data.image)
        .then(blobFile => {
          this.uploadCustomerImage(
            {
              id: this.customer._id,
              mimeType: 'image/jpeg',
              name: 'image.jpg',
              attachment: blobFile
            }
          )
            .then(() => {
              this.getCustomer()
                .then(res => {
                  this.currentTimestamp = new Date().getTime()
                  this.isEditingImage = false
                })
            })
        })
    },

    additionalDataSaved () {
      this.getCustomer()
      this.isEditingAdditionalDataForm = false
    },

    enableEditAdditionalData () {
      this.isEditingAdditionalDataForm = true
    },

    enableEditImage () {
      this.tireiFoto = false
      this.isEditingImage = true
    }
  },

  mounted () {
    this.resetCustomer()
    this.resetWinner()
    this.resetUrlImg()
    this.hasImage = false
    this.fetchUsers({limit: 99})
    this.getCustomer()
    this.fetchEvents({ select: ['status', '_id', 'reference', 'place', 'city'], limit: 99999 })
    this.fetchTickets({ where: [{ customerId: this.id }], limit: 9999 })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/TicketsIndex.vue